import React, { createContext, useCallback, useContext, useState } from 'react';

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const [state, setState] = useState({ open: false, returnTo: null, message: null, initialTab: 'signin' });

  const openLoginModal = useCallback((options = {}) => {
    setState({
      open: true,
      returnTo: options.returnTo || null,
      message: options.message || null,
      initialTab: options.initialTab || 'signin',
    });
  }, []);

  const closeLoginModal = useCallback(() => {
    setState({ open: false, returnTo: null, message: null, initialTab: 'signin' });
  }, []);

  return (
    <LoginModalContext.Provider value={{ ...state, openLoginModal, closeLoginModal }}>
      {children}
    </LoginModalContext.Provider>
  );
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) throw new Error('useLoginModal must be used within LoginModalProvider');
  return ctx;
}
